import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AssetUIModel, ClientCoreModule, OptionsLabelPipe, ValueListsService } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';
import { getProductList, getSubCategoryList } from '../../../../../../../../customer/customer-metadata-config';
import { Category } from '../../../../../../../../customer/vorwerk/vorwerk-metadata-config';
import { CustomTitleCasePipe } from '../../../../../../../../pipes/custom-title-case.pipe';
import { AssetCommonService } from '../../../../../../../../services/asset-common.service';
import { AssetMetadata } from '../../../../../models/asset-info.interface';

@Component({
  selector: 'thehubz-vorwerk-asset-metadata',
  templateUrl: './vorwerk-asset-metadata.component.html',
  styleUrl: './vorwerk-asset-metadata.component.scss',
  standalone: true,
  imports: [CommonModule, ClientCoreModule, CustomTitleCasePipe],
})
export class VorwerkAssetMetadataComponent implements OnChanges {
  @Input() assetInfoObject!: AssetMetadata;
  @Input() editFlag = false;
  @Input() asset!: AssetUIModel;

  assetDomains: AnyType[] = [];

  constructor(
    protected assetCommonService: AssetCommonService,
    protected valueListsService: ValueListsService,
    private optionsLabel: OptionsLabelPipe,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['asset']?.currentValue) {
      this.assetDomains = [];
      this.asset = changes['asset'].currentValue;
      this.asset.domains?.forEach((domain: AnyType) => {
        const domainAgency = domain.agency._id || domain.agency;
        const domainClient = domain.client._id || domain.client;
        this.valueListsService.lookACB(domainAgency, domainClient, domain.brand).subscribe((data) => {
          if (domain.category) domain.category = this.optionsLabel.transform(domain.category, Category);
          if (domain.product) domain.product = this.optionsLabel.transform(domain.product, getProductList(data.brand?.name?.toLowerCase() || ''));
          if (domain.subcategory) domain.subcategory = this.optionsLabel.transform(domain.subcategory, getSubCategoryList(domain.product.toLowerCase()));
          this.assetDomains.push({ ...data, category: domain.category, product: domain.product, subcategory: domain.subcategory });
        });
      });
    }
  }
}
